











































import { Vue, Component, Prop } from "vue-property-decorator";
import CustomButton from "@/components/form/CustomButton.vue";
import { Action as IAction } from "@/api-v2/learning-requests/models";
import CField from "@/components/form/CField.vue";
import CMultiSelect from "@/components/form/CMultiSelect.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";

@Component({
  components: { CSingleSelect, CMultiSelect, CField, CustomButton }
})
export default class ProfileStatusForm extends Vue {
  @Prop() statuses!: any;
  @Prop() actions!: Array<IAction>;
  @Prop() formProp!: any;
  @Prop() loading!: boolean;
  action: string = "";
  form: any = {
    title: "",
    actions: [],
    nextStatuses: [],
    editable: false
  };

  addStatus() {
    this.form.actions = [this.action];
    this.$emit("submit", this.form);
  }

  created() {
    if (this.formProp) {
      this.form = this.formProp;
      this.action = this.formProp.actions[0];
    }
  }
}
